import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeDrugRoute } from "../Entity/TreeNodeDrugRoute";
import { ErrorType } from "../../ErrorType";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeDrugRouteList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Drug Routes ({param})');
      this.parent = parent;
      this.labelNodeName = 'Drug Routes';
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let node = new TreeNodeDrugRoute(this.ioc!, this);
      this.children?.push(node);
  
      this.refreshLabel();
      return [node];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeDrugRouteList = new TreeNodeDrugRouteList(
        this.ioc!,
        newParent
      );
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  
    override getMessage(): any {
      let adminroutes: Art57Node[] = [];
      this.children?.forEach((node) => {
        let adminroute = node as Art57Node;
        adminroutes.push(adminroute.getMessage());
      });
      if (adminroutes.length > 0) {
        return { adminroutes: { adminroute: adminroutes } };
      } else {
        return undefined;
      }
    }
  
    override getHeaders(): string[] {
      return ['Drug Route'];
    }
  
    override validateBusinessRules(): any[] {
      let errors: any = [];
      if (!this.children || this.children.length == 0) {
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.bussinessValidationError,
          controlId: undefined,
          controlLabel: '',
          error: 'Section is Mandatory',
        });
      } else {
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.errorInactive,
          controlId: undefined,
          controlLabel: '',
          error: '',
        });
      }
  
      return errors;
    }
  }

